/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_copy': {
    width: 19,
    height: 22,
    viewBox: '0 0 19 22',
    data: '<defs><path pid="0" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" id="svgicon_icon_copy_a"/></defs><g transform="translate(-2 -1)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_copy_b" _fill="#fff"><use xlink:href="#svgicon_icon_copy_a"/></mask><g mask="url(#svgicon_icon_copy_b)" _fill="#898D94"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_copy.js